import styled from "styled-components";

export const StyledUploadImageBox = styled.div<{ themeColor: string, campaignColor?: string }>`
    margin: 15px 0px 16px;
    background-color: #fff;
    background-color: ${(p) => p.campaignColor ? p.campaignColor : 'rgba(0, 162, 147, 0.08)'};
    border-radius: 20px;
    text-align: center;
    height: auto;
    min-height: 200px;
    position: relative;
    line-height: 0;
    .dont-have-img {
        cursor: pointer;
        position: absolute;
        width: 100%;
        top: 50%;
        transform: translateY(-50%);
    }
    svg {
        margin-bottom: 10px;
    }
    .have-img {
        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 16px;
        }
    }
    .color-span {
        color: ${(p) => p.themeColor};
    }
`;
